import { render, staticRenderFns } from "./BylawPage.vue?vue&type=template&id=5a5c4dc3&scoped=true&"
import script from "./BylawPage.vue?vue&type=script&lang=js&"
export * from "./BylawPage.vue?vue&type=script&lang=js&"
import style0 from "./BylawPage.vue?vue&type=style&index=0&id=5a5c4dc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c4dc3",
  null
  
)

export default component.exports